const AppReferralBanner = ({mobile = true, preview = true}) => {

  return (
    <div className={`w-full app-top-mg overflow-hidden${mobile ? ' app-side-pd app-rounded' : ' app-rounded'}`}>
      <div
        className="bg-none relative text-white">
        <img src="/images/referral.png" alt="Namaste Doctor" className="app-rounded w-full"/>

        <div className="absolute top-3 ml-3 preview-zoom-2">
          <div className="text-xxs mb-2">OFFER</div>
          <div className="font-bold text-xs leading-none">Refer Friends</div>
          <div className="text-xxs">Get Referral Points</div>
        </div>

        <div
          className="absolute text-xxs ml-3 bottom-2 bg-primaryApp app-rounded leading-none w-16 h-16 text-center flex flex-col justify-center preview-zoom-2">
          <div className="mb-1">My Points</div>
          <div className="font-bold">400.0</div>
        </div>

        <div
          className="absolute bottom-2 right-5 bg-white md:w-48 app-rounded p-1 text-xs text-dark preview-zoom-2">
          <span className="ml-3">HgjRdf</span>
        </div>
        <div className="absolute bottom-2 right-5 bg-primaryApp w-32 app-rounded p-1 text-xs font-bold preview-zoom-2">
          <span className="ml-5">copy</span>
        </div>
        <div
          className="absolute bottom-2 right-5 bg-secondaryApp w-16 app-rounded p-1 text-xs text-center font-bold preview-zoom-2">
          Share
        </div>
      </div>
    </div>
  );
};

export default AppReferralBanner;